import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4da5575c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "BlackWhiteDotRenderContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mt16"
}, "请依次点击每行的操作按钮，点击后将闪烁该行所要进行的变换，所有行变换结束后选出最终的图形。", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "1、变换过程中如果超出格子，则表示从另一侧出现，例如：第一行最左侧的点进行“向左”变换后，将变到第一行最右侧的点。", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "2、变换为类似“逻辑与”计算，即 黑+黑 = 黑，黑+白 = 黑，白+白 = 白。", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_BlackWhiteDotGraph = _resolveComponent("BlackWhiteDotGraph");
  const _component_BlackWhiteDotAnimation = _resolveComponent("BlackWhiteDotAnimation");
  const _component_el_button = _resolveComponent("el-button");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$props.reviewMode ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "background": "#1388ff",
          "color": "white"
        },
        class: "ptr opd6 brd4",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, "结束回看")) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _hoisted_4, _hoisted_5, _hoisted_6, _createVNode(_component_el_row, {
    class: "bothCenter mt16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_BlackWhiteDotGraph, {
        board: $props.data.board
      }, null, 8, ["board"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_BlackWhiteDotAnimation, {
        speed: $props.difficulty.flashInterval * 1000,
        ref: "flashAnimation"
      }, null, 8, ["speed"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex flex-col bothCenter"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.sequences, (seq, seqi) => {
        return _openBlock(), _createBlock(_component_el_row, {
          key: `seq_${seqi}`,
          class: "mb10"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: $event => _ctx.$refs.flashAnimation.play(seq)
          }, {
            default: _withCtx(() => [_createTextVNode("展示第" + _toDisplayString(seqi + 1) + "行变换", 1)]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_AnswerButtonGroup, {
    onChoose: $options.onChoosed,
    review: $props.review,
    reviewMode: $props.reviewMode,
    options: $data.letters.slice(0, $props.data.options.length),
    ref: "answerBtns"
  }, {
    default: _withCtx(optionIndex => [_createVNode(_component_BlackWhiteDotGraph, {
      board: $props.data.options[optionIndex.index]
    }, null, 8, ["board"])]),
    _: 1
  }, 8, ["onChoose", "review", "reviewMode", "options"]), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "flex flex-col bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      style: _normalizeStyle({
        color: $props.review.result ? 'green' : 'red'
      })
    }, " 您的答案：" + _toDisplayString($props.review.answer), 5)) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true)]);
}